export function waitFor(conditionFunction: () => boolean, timeout = 250) {
    const poll = (resolve?: any) => {
        if (conditionFunction()) {
            resolve();
        } else {
            setTimeout(() => poll(resolve), timeout);
        }
    };

    return new Promise(poll);
}
